import type { AdConfig, AdPlacementConfig, PlacementName } from '@/app_lib/types/Ad';

export class AdLibrary {
  private static instance: AdLibrary; // eslint-disable-line

  private config!: AdConfig;

  private initialized: boolean;

  static getInstance(): AdLibrary {
    if (!AdLibrary.instance) {
      AdLibrary.instance = new AdLibrary();
    }

    return AdLibrary.instance;
  }

  private constructor() {
    this.initialized = false;
  }

  init(config: AdConfig) {
    if (this.initialized) {
      return;
    }
    this.initialized = true;
    this.config = config;
  }

  getPlacementConfig = (placementName: PlacementName): AdPlacementConfig => {
    const config = this.config.placements.find((placementConfig) => placementConfig.name === placementName);

    if (!config) {
      throw new Error(`Placement ${placementName} is not configured!`);
    }
    return config;
  };
}
